<template>
	<div class="index">
		<!-- 页面容器 -->
		<div class="page-container">
			<!-- 顶部标题与筛选区 -->
			<div class="header">
				<h2 class="title">订单信息</h2>
				<h2 @click="handleLogout" class="title">{{ adminInfo.realName }}:{{ adminInfo.username }}</h2>
			</div>

			<el-config-provider :locale="zhCn">
				<!-- 订单表格 -->
				<el-table :data="filterOrderList" border stripe class="order-table"
					:header-cell-style="{ backgroundColor: '#7eb8e7', color: '#fff', fontWeight: '600' }"
					:row-class-name="getRowClassName" highlight-current-row>
					<el-table-column prop="name" label="姓名" align="center" />
					<el-table-column prop="idCard" label="身份证号" align="center" />
					<el-table-column prop="phone" label="电话" />
					<el-table-column prop="address" label="收件地址" align="center" />
					<el-table-column prop="auditStatusVal" label="审核状态" align="center" />
					<el-table-column prop="auditRemark" label="审核意见" align="center" />
					<el-table-column prop="auditorName" label="审核人" align="center" />
					<el-table-column prop="auditTime" label="审核时间" align="center" />
					<el-table-column prop="createTime" label="创建时间" align="center" />
					<el-table-column label="操作" align="center">
						<template #default="scope">
							<el-button type="text" :disabled="scope.row.auditStatusVal !== '待审核'" size="small"
								@click="viewDetail(scope.row, 1)">通过</el-button>
							<el-button type="text" :disabled="scope.row.auditStatusVal !== '待审核'" size="small"
								@click="viewDetail(scope.row, 2)">拒绝</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页组件 -->
				<el-pagination class="pagination" @current-change="handleCurrentChange" :current-page="currentPage"
					:page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
			</el-config-provider>

		</div>
	</div>
</template>

<script>
import axios from '@/axios/create';
import { defineComponent } from 'vue';
import { mapMutations } from "vuex";
import zhCn from 'element-plus/lib/locale/lang/zh-cn'
// 引入Element UI组件（需确保已全局注册Element UI）
import { ElButton, ElInput, ElMessage, ElMessageBox, ElPagination, ElTable, ElTableColumn, ElTag } from 'element-plus';

export default defineComponent({
	name: 'index',
	components: {
		ElTable,
		ElTableColumn,
		ElTag,
		ElButton,
		ElInput,
		ElPagination
	},
	data() {
		return {
			zhCn,
			searchText: '', // 搜索文本
			currentPage: 1, // 当前页码
			pageSize: 15, // 每页条数
			orderList: [], // 订单列表（当前页）
			total: 0, // 总条数
			adminInfo: {}
		}
	},
	computed: {
		// 筛选后的订单列表
		filterOrderList() {
			if (!this.searchText) return this.orderList;
			return this.orderList.filter(item => {
				return true;
			});
		},
	},
	mounted() {
		this.getAdminInfo();
		this.getOrderList();
	},
	created() {

	},
	watch: {},
	methods: {
		...mapMutations(["setSaToken"]),
		handleLogout() {
			ElMessageBox.confirm(
				'确认退出登录吗?',
				'提示',
				{
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'success',
				}).then(() => {
					this.logoutRequest();
				}).catch(() => {
				})
		},
		logoutRequest() {
			axios.post('/admin/logout').then((res) => {
				if (res.code === 200) {
					ElMessage.success('退出成功');
					this.setSaToken('');
					setTimeout(() => {
						this.$router.push('/');
					}, 1000)
				} else {
					ElMessage.error(res.message || '退出失败');
				}
			})
		},
		getAdminInfo() {
			axios.get('/admin/info').then((res) => {
				if (res.code === 200) {
					this.adminInfo = res.data;
				}
			})
		},
		// 获取订单列表（带分页和搜索）
		getOrderList() {
			const params = {
				pageNum: this.currentPage,
				pageSize: this.pageSize,
			};
			axios.get('/userInfo/page', params).then((res) => {
				if (res.code === 200) {
					this.orderList = res.data.records.map(item => {
						if (item.auditStatus === 0) {
							item.auditStatusVal = '待审核';
						} else if (item.auditStatus === 1) {
							item.auditStatusVal = '审核通过';
						} else if (item.auditStatus === 2) {
							item.auditStatusVal = '审核拒绝';
						}
						return {
							...item,
						}
					});
					this.total = res.data.total; // 从接口获取总条数
				}
			}).finally(() => {

			});
		},
		// 搜索
		handleSearch() {
			this.currentPage = 1; // 搜索后回到第一页
			this.getOrderList();
		},
		// 自定义表格行样式
		getRowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? 'even-row' : 'odd-row';
		},
		// 查看详情
		viewDetail(row, status) {
			this.auditOrder(row, status);
		},
		inputValidator(value) {
			return value.length <= 50;
		},
		auditOrder(row, status) {
			ElMessageBox.prompt('请输入审核意见', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValidator: this.inputValidator,
				inputErrorMessage: '最大50个字符',
				inputPlaceholder: "审核意见（可不填）"
			}).then(({ value }) => {
				if (value.length > 50) {
					return ElMessage.error('审核意见不能超过50个字符');
				}
				this.auditRequest(row, status, value);
			}).catch(() => { })
		},
		auditRequest(row, status, value) {
			axios.protists.post('/userInfo/audit', {
				id: row.id,
				auditStatus: status,
				auditRemark: value,
			}).then((res) => {
				if (res.code === 200) {
					this.getOrderList(); // 刷新列表
					ElMessage.success(res.message);
				} else {
					ElMessage.error(res.message || '操作失败');
				}
			})
		},
		// 当前页改变
		handleCurrentChange(val) {
			this.currentPage = val;
			this.getOrderList(); // 重新请求数据
		},
	},
});
</script>

<style lang="scss" scoped>
.index {
	min-height: 100vh;
	max-height: 100vh;
	background-color: #f5f7fa;
	padding: 20px;

	.page-container {
		min-height: calc(100vh - 40px);
		max-height: calc(100vh - 40px);
		margin: 0;
		background-color: #fff;
		border-radius: 12px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
		padding: 24px;
		overflow: hidden;

		.header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			.title {
				font-size: 20px;
				font-weight: 600;
				color: #1f2937;
				margin: 0;
				white-space: nowrap;

				&:hover {
					color: #409eff;
				}
			}

			.search-input {
				width: 300px;
			}
		}

		.order-table {
			--el-table-header-text-color: #fff;
			--el-table-row-hover-bg-color: #e8f4ff;
			border-radius: 8px;
			overflow: hidden;
			height: calc(100vh - 200px);

			.even-row {
				background-color: #f9fafc;
			}

			.odd-row {
				background-color: #fff;
			}
		}

		.pagination {
			margin-top: 20px;
			display: flex;
			justify-content: center;
		}
	}
}

// Element UI样式优化
.el-tag {
	padding: 3px 8px;
	border-radius: 4px;
	font-size: 12px;
}

.el-button--text {
	color: #1989fa;

	&:hover {
		color: #0f6cbd;
	}
}
</style>
